module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./PayQRCodeView.js"));
	}, "PayMentView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PayMentView!./src/pages/Shop/PayMent/PayQRCode/PayQRCodeView.js
// module id = 1368
// module chunks = 418